// El precio guardado del producto es el precio final a tienda, con impuestos incluidos.
// Los impuestos se desglosan hacia atras y el total de la orden no cambia:
//   base = (precio - impuesto azucarado) / (1 + iva)
// Las lineas sin IVA definido (maquilas, ordenes anteriores) y las que tienen los
// impuestos desactivados con el switch de la cotizacion van completas a la base.
// Misma logica que RequestedOrderController::calculateTaxes en el backend.

const round2 = (amount) => Math.round(amount * 100) / 100;

const hasIvaDefined = (product) => !(product.iva_percentage === null || product.iva_percentage === undefined || product.iva_percentage === '');

// las lineas viejas no traen el campo: se toman como activadas
export const taxesEnabled = (product) => !(product.taxes_enabled === false || product.taxes_enabled === 0 || product.taxes_enabled === '0');

const hasTaxInfo = (product) => hasIvaDefined(product) && taxesEnabled(product);

// desglose de una linea sin redondear; los totales de la orden redondean al final
// para cuadrar centavo a centavo con el backend
const lineTaxesRaw = (product) => {
    const quantity = parseInt(product.quantity) || 0;
    const line_total = (parseFloat(product.product_price) || 0) * quantity;

    if (!hasTaxInfo(product)) {
        return { has_tax_info: false, line_total, iva: 0, sugar_tax: 0 };
    }

    const sugar_tax = (parseFloat(product.sugar_tax) || 0) * quantity;
    const taxed = line_total - sugar_tax;
    const iva = taxed - taxed / (1 + (parseFloat(product.iva_percentage) || 0) / 100);
    return { has_tax_info: true, line_total, iva, sugar_tax };
}

// Desglose de una sola linea (precio x cantidad). Con quantity 1 sirve para un producto suelto.
export const calculateLineTaxes = (product) => {
    const raw = lineTaxesRaw(product);
    const iva = round2(raw.iva);
    const sugar_tax = round2(raw.sugar_tax);
    return {
        has_tax_info: raw.has_tax_info,
        has_iva_defined: hasIvaDefined(product),
        taxes_enabled: taxesEnabled(product),
        line_total: round2(raw.line_total),
        taxable_base: round2(raw.line_total - iva - sugar_tax),
        iva,
        sugar_tax,
    };
}

export const calculateOrderTaxes = (products) => {
    let lines_total = 0;
    let iva_total = 0;
    let sugar_tax_total = 0;
    let has_tax_info = false;

    products.forEach((product) => {
        const line = lineTaxesRaw(product);
        lines_total += line.line_total;
        if (!line.has_tax_info) {
            return;
        }
        has_tax_info = true;
        iva_total += line.iva;
        sugar_tax_total += line.sugar_tax;
    });

    iva_total = round2(iva_total);
    sugar_tax_total = round2(sugar_tax_total);

    return {
        has_tax_info,
        taxable_base: round2(lines_total - iva_total - sugar_tax_total),
        iva_total,
        sugar_tax_total,
    };
}

// los campos de costo total de las ordenes muestran el numero sin formato;
// aqui igual, pero con los centavos que traen los impuestos
export const formatTaxAmount = (amount) => Number(amount || 0).toFixed(2);

export default {
    taxesEnabled,
    calculateLineTaxes,
    calculateOrderTaxes,
    formatTaxAmount,
}
